module.exports = __webpack_public_path__ + "6d964061693b3dbf6195d87991619892.png";